const dev = {
  // Set the URL for local development if needed.Currently using the production server
  API_ENDPOINT_URL: "https://localhost:7155/",
};

const prod = {
  API_ENDPOINT_URL: "https://rmeventb.shiftnext.in/",
};

const test = {
  API_ENDPOINT_URL: "/api",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
